export default __webpack_public_path__ + "static/media/about-us-hero.75c0ebc3.jpg";